interface Props {
    lang: string,
    className?: string
}

const getCountryCode = (lang: string): string => {
    const map: Record<string, string> = {
        en: 'GB',
        ru: 'RU',
        // будет дополнятся по мере необходимости
    };
    return map[lang] ?? lang.toUpperCase();
};

const getCountryFlagIconPath = (lang: string): string => {
    const code = getCountryCode(lang);
    return require(`@/assets/icons/flags/${code}.svg`);
};

export const CountryFlag: React.FC<Props> = ({ lang, className }) => {
    return (
        <img
            src={getCountryFlagIconPath(lang)}
            className={className} />
    )
}
